import { render, staticRenderFns } from "./ContentFooter.vue?vue&type=template&id=60c2a33a&scoped=true"
import script from "./ContentFooter.vue?vue&type=script&lang=js"
export * from "./ContentFooter.vue?vue&type=script&lang=js"
import style0 from "./ContentFooter.vue?vue&type=style&index=0&id=60c2a33a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c2a33a",
  null
  
)

export default component.exports